'use strict';
/**
 * 兼容IE6的懒加载
 */
var fns = require('@tencent/fns')
var Message = require('@tencent/message')
var message = new Message()
var getParentScrollInfo = require('./parentScroll')
var ieEvent = !document.addEventListener
var _conf = {
    /**
     * throttle scroll emit throttle
     */
}

var hasListen = false
function listenViewEvent(){
  bindEvent(window, 'scroll', onScroll)
  bindEvent(window, 'resize', onScroll)
}


/**
 * Call when element is onviewing
 * @param  {HTMLElement}   el [description]
 * @param  {Object}        options
 *         - visible      <Boolean>      仅当元素在当前视窗内有露出时触发，默认为 true
 *         - offsetTop    <Number>       距离滚动位置顶端的偏移，默认 0
 *         - offset       <Number>       上下的偏移，默认 0
 *         - enter        <Boolean>      仅当元素从可见到不可见时触发，默认 false
 *         - recalc       <Boolean>      每次滚动事件都重新计算元素的位置，有性能问题，默认 false
 *         - once         <Boolean>      可见回调只触发一次，默认 false
 *         - listenHoriz  <Boolean>      需要监听水平事件的返回真实曝光，只在文档滚动模式下生效，默认 false
 *         - inview       <Boolean>      仅当元素完全露出，前提条件是 visible 为 true，默认 false
 *         - throttle     <Number>       滚动限流时间
 *         - horiz        <Boolean>      指定为横向滚动
 *         - absoluteCalc <Boolean>      用视窗的绝对位置计算
 *         - out          <Function>     call when outview
 * @param  {Function}      cb onview callback
 * @return {Function}      unwatch
 */
function Onview(el/*[, options]*/, cb) {

    //默认不监听scroll, 只有有元素时监听， 
    //解决部分库引用了onview没有执行， 也会listen, 读dom属性导致reflow卡顿的问题， 低端移动设备明显
    if(!hasListen){
      hasListen = true
      listenViewEvent()
    }

    var options = {}
    var args = arguments
    // (el, options, cb)
    if (fns.type(cb) == 'object') {
        options = cb
        cb = args[2]
    }
    var visibleOnly = getBool(options, 'visible', true)
    var enterOnly = getBool(options, 'enter', false)
    var recalc = getBool(options, 'recalc', false)
    var inviewOnly = getBool(options, 'inview', false)
    var horizOnly = getBool(options, 'horiz', false)
    var absoluteCalc = getBool(options, 'absoluteCalc', false)
    var offsetTop = options.offsetTop || 0

    var parentScrollObj = getParentScrollInfo(el)

    if ( !fns.some(parentScrollObj.parents, function(parent){
        return document.body === parent
    }) ) {
        // on mounted
        var _unbind
        var timer = setTimeout(function () {
            _unbind = bind(getParentScrollInfo(el).scrollParent)
        })
        return function () {
            clearTimeout(timer)
            if (_unbind) _unbind()
        }
    } else {
        return bind(parentScrollObj.scrollParent)
    }

    function bind(parent) {
        var isDocumentScrolling = !parent || parent === document.body
        var absOffset
        var parentHeight,parentWidth,parentLeft,parentTop

        if (isDocumentScrolling && !recalc) {
            // 静态计算的方式性能更友好
            // 缺点：动态变化尺寸会导致判断错误
            absOffset = getAbsoluteOffset(el)
        } else if (!isDocumentScrolling && !recalc) {
            var parentRect = parent.getBoundingClientRect();
            parentHeight = parentRect.height
            parentWidth = parentRect.width
            parentLeft = parentRect.left
            parentTop = parentRect.top
        }

        var onviewing = false
        var triggered = false
        var _handler = function (scrollTop, clientHeight, clientWidth) {
            if (options.once && triggered) return
            var viewed
            
            if (isDocumentScrolling) {
                // 全局滚动使用静态计算
                absOffset = recalc || !absOffset.height ? getAbsoluteOffset(el) : absOffset;

                // 没高度就不算
                if (!absOffset.height) return

                var t = absOffset.top - offsetTop
                var b = absOffset.bottom

                if (options.offset) {
                    t = t - options.offset
                    b = b + options.offset
                }
                var isHorizVisible = options.listenHoriz ? absOffset.left >= 0 && absOffset.right <=  clientWidth : true
                if (visibleOnly) {
                    if (inviewOnly) {
                        // 完全露出
                        viewed = t >= scrollTop && b <= (scrollTop + clientHeight)
                    } else {
                        // 只露出一点
                        viewed = t < (scrollTop + clientHeight) && b > scrollTop
                    }
                    viewed = viewed && isHorizVisible
                } else {
                    viewed = isHorizVisible && (scrollTop + clientHeight) > t
                }

            } else if (!isDocumentScrolling) {
                // 局部滚动使用动态计算
                var rect = el.getBoundingClientRect()
                // 没宽高就不算
                if (!rect.height || !rect.width) return
                if(!absoluteCalc){ //非绝对计算， 默认起用
                  if (!parentHeight || !parentWidth || !parentTop) {
                    var parentRect = parent.getBoundingClientRect();
                    parentHeight = parentRect.height
                    parentWidth = parentRect.width
                    parentTop = parentRect.top
                    parentLeft = parentRect.left
                  }
                  var h = rect.height
                  var w = rect.width
                  var t = rect.top - parentTop
                  var l = rect.left - parentLeft
                  var b =  rect.bottom - parentTop
                  var r = rect.right - parentLeft
                  var offset = options.offset
                  if (options.offset) {
                      t += offset
                      l += offset
                      b -= offset
                      r -= offset
                  }
                  if (visibleOnly) {
                    if (inviewOnly) {
                        viewed = horizOnly ? (l >= 0 && r <= parentWidth ) : (t >= 0 && b <= parentHeight)
                    } else {
                        viewed = horizOnly ? (l > -w && l < parentWidth) : (t > -h && t < parentHeight)
                    }
                  } else {
                      viewed = t < parentHeight && l < parentWidth
                  }
                } else {
                  viewed = isInScreen(el, rect)
                }
            }

            var lastViewState = onviewing
            // outview
            if (lastViewState && !viewed){
                typeof options.out == 'function' && options.out();
            }

            if (!viewed) {
                onviewing = false
                return
            } else {
                onviewing = true
            }
            if ((enterOnly && !lastViewState) || !enterOnly) {
                triggered = true
                cb && cb()
            }
        }

        var unwatch
        var unbind, unbindOnview

        if (isDocumentScrolling) {
            unwatch = message.on('scroll', _handler)
            // scroll delegate
            onScroll()
        } else {
            var parentVisible = false
            var calling
            var _h = function () {
                if (calling) return
                calling = true
                setTimeout(function () {
                    calling = false
                    parentVisible && _handler(getScrollTop(), getClientHeight(), getClientWidth())
                }, _conf.throttle ? _conf.throttle : 100)
            }
            unwatch = message.on('scroll', _h)
            if (parent._onviewDelegator) {
                parentVisible =  parent._onviewDelegator.visible()
                unbindOnview = parent._onviewDelegator.message.on('visible', function (visible) {
                    parentVisible = visible
                    visible && _h()
                })
                _h()
            } else {
                var msg = new Message()
                parent._onviewDelegator = {
                    message: msg,
                    visible: function () {
                        return parentVisible
                    }
                }
                unbindOnview = Onview(parent, fns.extend({}, options, {
                    inview: true,
                    enter: true,
                    offset: 0,
                    listenHoriz: false,
                    out: function () {
                        msg.emit('visible', false)
                        parentVisible = false
                    }
                }), function () {
                    parentVisible = true
                    msg.emit('visible', true)
                    _h()
                })
            }


            unbind = bindEvent(parent, 'scroll', _h)
            _h()
        }
        // unbind
        return function () {
            unwatch && unwatch()
            unbind && unbind()
            unbindOnview && unbindOnview()
            unwatch = unbind = unbindOnview = null
        }
    }
}
Onview.set = function (k, v) {
    _conf[k] = v
    return Onview
}

Onview.message = message;
message.on('update',onScroll);

module.exports = Onview

var lock
function onScroll () {
    if (_conf.throttle) {
        if (lock) return
        else {
            lock = true
            setTimeout(function () {
                lock = false
                message.emit('scroll', getScrollTop(), getClientHeight(), getClientWidth())                        
            }, _conf.throttle)
        }
    } else {
        message.emit('scroll', getScrollTop(), getClientHeight(), getClientWidth())
    }
}
function getScrollTop () {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
}
function getClientHeight () {
    if (document.compatMode == 'BackCompat') {
        return document.body.clientHeight
    } else {
        return document.documentElement.clientHeight
    }
}

function getClientWidth() {
    if (document.compatMode == 'BackCompat') {
        return document.body.clientWidth
    } else {
        return document.documentElement.clientWidth
    }
}

function getAbsoluteOffset (el) {
    var rect = el.getBoundingClientRect()
    return {
        top: rect.top + getScrollTop(),
        left: rect.left,
        right: rect.right,
        bottom: rect.bottom + getScrollTop(),
        height: rect.bottom - rect.top
    }
}
function bindEvent(el, type, fn) {
    if (ieEvent) {
        el.attachEvent('on'+type, fn)
    } else {
        el.addEventListener(type, fn)
    }
    return function () {
        unbindEvent(el, type, fn)
    }
}
function unbindEvent(el, type, fn) {
    if (ieEvent) {
        el.detachEvent('on'+type, fn)
    } else {
        el.removeEventListener(type, fn)
    }
}
function getBool(opts, prop, defaultValue) {
    if (!opts.hasOwnProperty(prop)) return defaultValue
    return !!opts[prop]
}


var w = window.innerWidth // 视窗的宽度
var h = window.innerHeight // 视窗的高度
function isInScreen(el, bcr, options) {
  options = Object.assign({}, { 
    top: 0, 
    right: 0, 
    bottom: 0, 
    left: 0 
  }, options)
  // 取得元素在可视区的位置（相对浏览器视窗）左右上下
  var bcr = bcr || el.getBoundingClientRect()
  // padding+border+width
  var mw = el.cacheOffsetWidth = el.cacheOffsetWidth || el.offsetWidth // 元素自身宽度
  var mh = el.cacheOffsetHeight = el.cacheOffsetHeight || el.offsetHeight // 元素自身的高度
  var boolX = (!((bcr.right - options.left) <= 0 && ((bcr.left + mw) - options.left) <= 0) && !((bcr.left + options.right) >= w && (bcr.right + options.right) >= (mw + w))) // 左右符合条件
  var boolY = (!((bcr.bottom - options.top) <= 0 && ((bcr.top + mh) - options.top) <= 0) && !((bcr.top + options.bottom) >= h && (bcr.bottom + options.bottom) >= (mh + h))) // 上下符合条件
  return el.width !== 0 && el.height !== 0 && boolX && boolY
}
  